import { render } from "./loginForm.vue?vue&type=template&id=1ad52277&scoped=true"
import script from "./loginForm.vue?vue&type=script&lang=js"
export * from "./loginForm.vue?vue&type=script&lang=js"

import "./loginForm.vue?vue&type=style&index=0&id=1ad52277&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad52277"]])

export default __exports__